export default __webpack_public_path__ + "static/media/655.ab5f46cc.jpg";